import { colors } from '../colors';
var MuiOutlinedInput = {
  styleOverrides: {
    root: {
      backgroundColor: colors.Neutros0,
      borderRadius: 8,
      'fieldset.MuiOutlinedInput-notchedOutline': {
        borderColor: colors.Neutros40
      },
      '&.Mui-focused fieldset.MuiOutlinedInput-notchedOutline': {
        borderColor: colors.WomCorp
      }
    }
  },
  defaultProps: {
    color: "primary"
  }
};
export default {
  MuiOutlinedInput: MuiOutlinedInput
};